import {isTouch, isWindows, detectBrowser} from './detect-device';

export const CLASSES = {
	active: 'is-active',
	open: 'is-open',
	fixedOnScroll: 'is-fixed-on-scroll',
	hidden: 'is-hidden',
	overflowed: 'is-overflowed',
	loading: 'is-loading',
	invisible: 'is-invisible',
	static: 'is-static',
	fixed: 'is-fixed',
	disabled: 'is-disabled',
	animated: 'is-animated',
	sticky: 'is-sticky',
	error: 'is-error',
	load: 'is-load',
	menuOpen: 'is-menu-open',
	mediaLoaded: 'is-media-loaded',
	mediaInited: 'is-media-inited',
};

export const IS_TOUCH = isTouch();
export const BROWSER = detectBrowser();
export const IS_WINDOWS = isWindows();

export const DOM = {
	body: document.body,
	headerWrapper: document.querySelector('.js-header-wrapper'),
	header: document.querySelector('.js-header'),
	headerOverlay: document.querySelector('.js-header-overlay'),
	burgerBtn: document.querySelector('.js-burger-btn'),
	seacrhBtn: document.querySelector('.js-search-btn'),
	seacrhInnerBtn: document.querySelector('.js-search-inner-btn'),
	mainMenu: document.querySelector('.js-header-main-drop'),
	searchMenu: document.querySelector('.js-header-search-menu'),
};

export const BREAKPOINTS = {
	for_k: 4000,
	xxl: 2600,
	lg: 1440,
	md: 1024,
	mobile: 992,
	sm: 768,
};


export const MAX_PHONE_SIZE = BREAKPOINTS.mobile;

let isPhone = false;

if(IS_TOUCH && window.innerWidth < MAX_PHONE_SIZE &&  window.innerHeight < MAX_PHONE_SIZE ) {
	isPhone = true;
}

export const IS_PHONE = isPhone;


let isTabletSmall = false;

if(!IS_PHONE && IS_TOUCH && window.innerWidth <= BREAKPOINTS.md &&  window.innerHeight <= BREAKPOINTS.md) {
	isTabletSmall = true;
}

export const IS_TABLET_SM = isTabletSmall;
window.IS_TABLET_SM = IS_TABLET_SM
export const IS_HOME_VERTICAL = IS_TOUCH && window.innerWidth <= BREAKPOINTS.md &&  window.innerHeight <= BREAKPOINTS.md;

export  const controlledVideoPlayers = [];

export const isHomePage = document.body.classList.contains('js-homepage');
export const isLandingPage = document.body.classList.contains('single-landing');
export const isPost = document.body.classList.contains('single-post');
export const IS_SAFARI = BROWSER.name === 'Safari'
export const IS_FIREFOX = BROWSER.name === 'Firefox'
export const IS_CHROME = BROWSER.name === 'Chrome'
